"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchRequestSchema = exports.filterRequestSchema = void 0;
const zod_1 = require("zod");
const ChangeItemType_1 = require("../../types/ChangeItemType");
const datetime_schema_1 = require("../../../common/schemas/datetime.schema");
const ChangeItemStatus_1 = require("../../types/ChangeItemStatus");
const unique_1 = require("../../../common/schemas/helpers/unique");
const contact_schema_1 = require("../../../common/schemas/contact.schema");
const uniqueForContact_1 = require("../../../common/schemas/helpers/uniqueForContact");
const Reason_1 = require("../../types/Reason");
const selectedItemWithSpecificTypeOrCustomName_schema_1 = require("../../../common/schemas/selectedItemWithSpecificTypeOrCustomName.schema");
const Keyword_1 = require("../../types/Keyword");
const uniqueForCustomizableValue_1 = require("../../../common/schemas/helpers/uniqueForCustomizableValue");
const enum_schema_1 = require("../../../common/schemas/enum.schema");
const ReceivedVia_1 = require("../../types/ReceivedVia");
const constants_1 = require("../../../common/constants");
const sortField_schema_1 = require("../../../common/schemas/sortField.schema");
const sortOrder_schema_1 = require("../../../common/schemas/sortOrder.schema");
const dateFilterSchema = zod_1.z
    .object({
    start: datetime_schema_1.datetimeSchema.optional(),
    end: datetime_schema_1.datetimeSchema.optional(),
})
    .strict();
exports.filterRequestSchema = zod_1.z
    .object({
    changeItemTypes: (0, enum_schema_1.enumSchema)(ChangeItemType_1.ChangeItemType)
        .array()
        .nonempty()
        .optional()
        .refine(...(0, unique_1.unique)("Change item types must be unique")),
    receivedDate: dateFilterSchema.optional(),
    dueDate: dateFilterSchema.optional(),
    createdDate: dateFilterSchema.optional(),
    isOverdue: zod_1.z.boolean().optional(),
    statuses: (0, enum_schema_1.enumSchema)(ChangeItemStatus_1.ChangeItemStatus, [ChangeItemStatus_1.ChangeItemStatus.Approved, ChangeItemStatus_1.ChangeItemStatus.Rejected])
        .array()
        .nonempty()
        .optional()
        .refine(...(0, unique_1.unique)("Statuses must be unique")),
    disciplines: zod_1.z
        .number()
        .int()
        .array()
        .nonempty()
        .optional()
        .refine(...(0, unique_1.unique)("Disciplines must be unique")),
    from: contact_schema_1.contactSchema
        .array()
        .nonempty()
        .optional()
        .refine(...(0, uniqueForContact_1.uniqueForContact)("From contacts must be unique")),
    recipients: contact_schema_1.contactSchema
        .array()
        .nonempty()
        .optional()
        .refine(...(0, uniqueForContact_1.uniqueForContact)("Recipients contacts must be unique")),
    reasons: (0, enum_schema_1.enumSchema)(Reason_1.Reason)
        .array()
        .nonempty()
        .optional()
        .refine(...(0, unique_1.unique)("Reasons must be unique")),
    keywords: (0, selectedItemWithSpecificTypeOrCustomName_schema_1.selectedItemWithSpecificTypeOrCustomNameSchema)(Keyword_1.Keyword)
        .array()
        .nonempty()
        .optional()
        .refine(...(0, uniqueForCustomizableValue_1.uniqueForCustomizableValue)(uniqueForCustomizableValue_1.uniqueKeywordsMessage)),
    receivedVia: (0, enum_schema_1.enumSchema)(ReceivedVia_1.ReceivedVia)
        .array()
        .nonempty()
        .optional()
        .refine(...(0, unique_1.unique)("Received via must be unique")),
    ids: zod_1.z
        .string()
        .array()
        .max(100)
        .nonempty()
        .optional()
        .refine(...(0, unique_1.unique)("Ids must be unique")),
})
    .strict()
    .optional();
exports.searchRequestSchema = zod_1.z
    .object({
    paging: zod_1.z
        .object({
        pageSize: zod_1.z.number().positive().max(constants_1.MAX_PAGE_SIZE_SEARCH_ITEMS).optional(),
        pageNumber: zod_1.z.number().positive().optional(),
    })
        .strict()
        .optional(),
    filter: exports.filterRequestSchema,
    query: zod_1.z.string().optional(),
    highlight: zod_1.z
        .object({
        openDelimiter: zod_1.z.string().optional(),
        closeDelimiter: zod_1.z.string().optional(),
        encoding: zod_1.z.enum(["none", "html"]).optional(),
    })
        .strict()
        .optional(),
    sort: zod_1.z
        .array(zod_1.z
        .object({
        field: sortField_schema_1.sortFieldSchema,
        order: sortOrder_schema_1.sortOrderSchema,
    })
        .strict())
        .optional(),
})
    .strict();
//# sourceMappingURL=searchRequest.schema.js.map